<template>
  <el-dialog :visible.sync="state" :title="plustitle" width="580px" custom-class="c-docs" :close-on-click-modal="false" @open="bindGetData">
    <div class="m-form">
      <el-form label-width="140px">
        <el-form-item label="应用ID" v-if="landData.state === 2">
          <span>{{ landData.id }}</span>
        </el-form-item>

        <el-form-item label="代理商名称">
          <el-input v-model.trim="landData.agentName" type="text" style="width: 100%" placeholder="请输入代理商名称" :maxlength="100" />
        </el-form-item>
        <el-form-item label="开票单位">
          <el-input v-model.trim="landData.field3" type="text" style="width: 100%" placeholder="请输入开票单位" :maxlength="100" />
        </el-form-item>
        <el-form-item label="银行账户名">
          <el-input v-model.trim="landData.field1" type="text" style="width: 100%" placeholder="请输入银行账户名" :maxlength="100" />
        </el-form-item>
        <el-form-item label="银行账号">
          <el-input v-model.trim="landData.field2" type="text" style="width: 100%" placeholder="请输入银行账号" :maxlength="100" />
        </el-form-item>
        <el-form-item label="开户行">
          <el-input v-model.trim="landData.field4" type="text" style="width: 100%" placeholder="请输入开户行" :maxlength="100" />
        </el-form-item>
      </el-form>
    </div>
    <!-- 提交表单 -->
    <template slot="footer">
      <div class="m-foot">
        <el-button @click="$emit('input', false)">取消</el-button>
        <el-button type="primary" :loading="loading" @click="save">
          <span v-if="loading">提交中...</span>
          <span v-else>确认</span>
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script>
import { trim } from '@/common/js/utils'
const getForm = () => {
  return {
    id: '',
    agentName: '',
    field3: '',
    field1: '',
    field2: '',
    field4: '',
    state: ''
  }
}
export default {
  name: 'ptomAgentInfoSet',
  props: {
    value: {
      type: Boolean
    },
    title: {
      type: String
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },

    edit: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    plustitle() {
      return `${this.edit ? '编辑' : '添加'}${this.title}`
    },
    rows() {
      return this.landData.docContent && this.landData.docContent.split(/\r?\n/).filter((ret) => trim(ret)).length
    }
  },
  methods: {
    bindGetData() {
      this.landData = getForm()
    },
    setForm(form) {
      this.landData = { ...form }
    },

    // 提交验证
    save() {
      if (!this.landData.agentName) {
        this.$message.error('代理商名称不能为空！')
        return
      }

      if (!this.landData.field3) {
        this.$message.error('开票单位不能为空！')
        return
      }
      this.$emit('on-save', this.landData)
    }
  },
  data() {
    return {
      landData: {
        ...getForm()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .c-docs {
  position: relative;

  .m-form {
    overflow: auto;
    max-height: 520px;

    .mark {
      color: skyblue;
    }

    .el-input__inner {
      font-size: 12px;
    }
  }

  .m-foot {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}
</style>
